












































































































































































































































































































import {
  ObjDirection,
  OptProblemDefinitionsBuilder,
  OptFacadeBuilder,
  OptProblem,
  OptProblemResults,
  HardCstr,
  Obj,
  Pct,
  SolutionDomain,
} from "@/mop_bindings";
import { Component, Vue } from "vue-property-decorator";
import BinhandKorn from "@/problems/BinhandKorn";
import Constr from "@/problems/Constr";
import Rastrigin from "@/problems/Rastrigin";
import SchafferFunction2 from "@/problems/SchafferFunction2";
import { dom } from "@fortawesome/fontawesome-svg-core";

const problems = [BinhandKorn, Constr, Rastrigin, SchafferFunction2];

interface ProblemDefinitions {
  domain: string[];
  hardCstrs: string[];
  maxIterations?: number;
  name: string;
  objs: { direction: ObjDirection; fn: string }[];
  resultsNum?: number;
  source: string;
  stagnationPercentage?: number;
  stagnationThreshold?: number;
}

@Component
export default class Problem extends Vue {
  domain: string[] = [];
  editableProblems: ProblemDefinitions[] = [];
  hardCstrs: string[] = [];
  hasValidDomainInput = true;
  hasValidObjsInput = true;
  isExamplesModalActivated = false;
  maxIterations = 500;
  ObjDirection = ObjDirection;
  objs: ProblemDefinitions["objs"] = [];
  results?: OptProblemResults;
  resultsNum = 100;
  stagnationPercentage = 1;
  stagnationThreshold = 50;

  addHardCstr() {
    this.hardCstrs.push("");
  }

  addObj() {
    this.hasValidObjsInput = true;
    this.objs.push({ direction: ObjDirection.Min, fn: "" });
  }

  beforeAddingDomain(domain: string) {
    const parts = domain.split("=");
    if (parts.length !== 2) {
      return false;
    }
    return this.isNumber(parts[0]) && this.isNumber(parts[1]);
  }

  clearProblem() {
    this.domain = [];
    this.objs = [];
    this.hardCstrs = [];
    this.$emit("hasResults", null);
  }

  async doSolve() {
    let opdbj = new OptProblemDefinitionsBuilder()
      .domain(new SolutionDomain(this.domain))
      .name("Problem");

    this.hardCstrs.forEach((x) => {
      const hc = new HardCstr(this.evalToFunction(x));
      opdbj = opdbj.push_hard_cstr(hc);
    });

    this.objs.forEach((x) => {
      const obj = new Obj(x.direction, this.evalToFunction(x.fn));
      opdbj = opdbj.push_obj(obj);
    });

    let problem = OptProblem.with_capacity(opdbj.build(), this.resultsNum);

    const facade = new OptFacadeBuilder()
      .max_iterations(this.maxIterations)
      .stagnation_percentage(Pct.from_percent(this.stagnationPercentage))
      .stagnation_threshold(this.stagnationThreshold)
      .build(problem);

    problem = await facade.solve(problem);

    this.results = problem.results();
  }

  evalToFunction(fn: string) {
    return (() => new Function("solution", `"use strict"; ${fn}`))();
  }

  fillInputsWithProblem(problem: ProblemDefinitions) {
    this.domain = problem.domain;
    this.hardCstrs = problem.hardCstrs || [];
    this.isExamplesModalActivated = false;
    this.maxIterations = problem.maxIterations || this.maxIterations;
    this.objs = problem.objs;
    this.resultsNum = problem.resultsNum || this.resultsNum;
    this.stagnationPercentage =
      problem.stagnationPercentage || this.stagnationPercentage;
    this.stagnationThreshold =
      problem.stagnationThreshold || this.stagnationThreshold;
    this.validateInputs();
    this.$emit("hasResults", null);
  }

  hasValidInputs(): boolean {
    return this.hasValidDomainInput && this.hasValidDomainInput;
  }

  isNumber(str: string) {
    return str.length !== 0 && isNaN(parseFloat(str)) === false;
  }

  mounted() {
    dom.watch();
  }

  removeHardCstr(idx: number) {
    this.hardCstrs.splice(idx, 1);
  }

  removeObj(idx: number) {
    this.objs.splice(idx, 1);
  }

  showExamplesModal() {
    this.editableProblems = JSON.parse(JSON.stringify(problems));
    this.isExamplesModalActivated = true;
  }

  async solve(e: Event) {
    e.preventDefault();
    this.validateInputs();
    if (this.hasValidInputs()) {
      window.location.hash = "results";
      this.$emit("hasResults", null);
      await this.doSolve();
      this.$emit("hasResults", this.results);
    }
  }

  validateInputs() {
    this.hasValidDomainInput = this.domain.length > 0;
    this.hasValidObjsInput = this.objs.length > 0;
  }
}
